const FundsVerification = () => import('@/views/main/report/fundsVerification/FundsVerification.vue')
export default {
  path: '/main/report/fundsVerification',
  name: 'fundsVerification',
  component: FundsVerification,
  children: []
}
